export default function Gallery() {
  const cases = [
    {
      category: 'ユニットバス交換',
      title: '築54年のタイル張りのお風呂をユニットバスに',
      duration: '4日',
      location: '船橋市海神',
      beforeImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/643fd34ea895137e61225624b3d4e69e.jpeg',
      afterImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/3a5315f411dba282fcc5afb9d3bea528.jpeg'
    },
    {
      category: 'ユニットバス交換',
      title: '汚れが中々落ちない悩みを新しいユニットバスで解決',
      duration: '3日',
      location: '船橋市高根台',
      beforeImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/0f58638467dadc120faed35ccf1ba727.jpeg',
      afterImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/5079004be813cace499b82a3b3c11321.jpeg'
    },
    {
      category: 'ユニットバス交換',
      title: '窓をなくして、断熱性能を極限まで',
      duration: '3日',
      location: '船橋市高根台',
      beforeImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/ce0b5063e96784b6da683b768746f8a9.jpeg',
      afterImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/d1bd29d9e9337348cdfa605c73d8457f.jpeg'
    },
    {
      category: 'ユニットバス交換',
      title: '戸建て住宅の浴室リニューアル',
      duration: '3日',
      location: '船橋市三山',
      beforeImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/cd2c08bd62617f4d6d35652af5384207.jpeg',
      afterImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/d4793403e4fcbaa0dd8dfef4786563f2.jpeg'
    },
    {
      category: 'ユニットバス交換',
      title: '浴室リフォームで暮らしに豊かさを',
      duration: '3日',
      location: '船橋市南三咲',
      beforeImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/e31dec22f188a128a8f4d34bcca3ca9e.jpeg',
      afterImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/33fb64b9e4d7f24774839c53ddfe4f98.jpeg'
    },
    {
      category: 'ユニットバス交換',
      title: '悩みをすべて解決したユニットバスへ',
      duration: '3日',
      location: '船橋市西習志野',
      beforeImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/fdf424472147b585c644a6ebb28c0c59.jpeg',
      afterImage: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/b98bf0fa530bd80e005ace8e011044a1.jpeg'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Title */}
        <div className="mb-16">
          <p className="text-sm text-gray-500 mb-3 tracking-wider">船橋市内での実績</p>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1a2b4a]">
            施工事例
          </h2>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cases.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
              {/* Before/After Images */}
              <div className="relative">
                <div className="grid grid-cols-2 gap-0">
                  <div className="relative">
                    <div className="w-full h-48">
                      <img 
                        src={item.beforeImage}
                        alt="Before"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="absolute top-3 left-3 bg-gray-800/80 text-white px-3 py-1 rounded-full text-xs font-bold">
                      Before
                    </div>
                  </div>
                  <div className="relative">
                    <div className="w-full h-48">
                      <img 
                        src={item.afterImage}
                        alt="After"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="absolute top-3 right-3 bg-[#ff8c42] text-white px-3 py-1 rounded-full text-xs font-bold">
                      After
                    </div>
                  </div>
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg">
                  <i className="ri-arrow-right-line text-[#1a2b4a] text-xl"></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="inline-block bg-[#e8f5e9] text-[#1a2b4a] px-4 py-1 rounded-full text-sm font-bold mb-4">
                  {item.category}
                </div>
                <h3 className="text-xl font-bold text-[#1a2b4a] mb-4 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    工期: {item.duration}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-map-pin-line"></i>
                    {item.location}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
